import { useState } from 'react';
import PropTypes from 'prop-types';
import { bandOfRatio } from './microSimBands';

/**
 * What the room said at each turn: one bar per reply, length = how many picked it,
 * colour = how much that reply earned. Grouped by round; one round open at a time.
 */
const ChoiceDistribution = ({ choices }) => {
  const rounds = [...new Set(choices.map((c) => c.round))];
  const [openRound, setOpenRound] = useState(rounds[0] ?? 0);

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {rounds.map((r) => (
          <button
            key={r}
            type="button"
            onClick={() => setOpenRound(r)}
            className={`rounded-full px-3 py-1 text-xs font-semibold ${openRound === r ? 'bg-neutral-900 text-white' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'}`}
          >
            Round {r + 1} · {choices.find((c) => c.round === r)?.roundTitle}
          </button>
        ))}
      </div>
      <div className="mt-3 space-y-4">
        {choices.filter((c) => c.round === openRound).map((c) => {
          const max = Math.max(1, ...c.options.map((o) => o.count));
          return (
            <div key={`${c.round}-${c.step}`}>
              <p className="text-xs font-semibold text-neutral-500">Turn {c.step + 1} · {c.prompt}</p>
              <div className="mt-1.5 space-y-1.5">
                {c.options.map((o) => {
                  const b = bandOfRatio(o.quality);
                  return (
                    <div key={o.id} className="grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-0.5 sm:grid-cols-[minmax(0,3fr)_minmax(0,2fr)_auto]">
                      <p className="text-xs text-neutral-700 sm:text-sm">{o.text}</p>
                      <span className="text-right text-xs font-bold tabular-nums text-neutral-900 sm:order-last">{o.count}</span>
                      <div className="col-span-2 h-2 overflow-hidden rounded-full bg-neutral-100 sm:col-span-1">
                        <div className="h-full rounded-full" style={{ width: `${(o.count / max) * 100}%`, backgroundColor: b.hex }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-[11px] text-neutral-400">Bar colour shows how much the reply earned: green strong, amber developing, red weak. Counts are finished pairs only.</p>
    </div>
  );
};

ChoiceDistribution.propTypes = { choices: PropTypes.array.isRequired };

export default ChoiceDistribution;
